import { render, staticRenderFns } from "./MyActions.vue?vue&type=template&id=1cf61fbf&scoped=true&"
import script from "./MyActions.vue?vue&type=script&lang=js&"
export * from "./MyActions.vue?vue&type=script&lang=js&"
import style0 from "./MyActions.vue?vue&type=style&index=0&id=1cf61fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf61fbf",
  null
  
)

export default component.exports